import {
    Dialog,
    DialogType,
    DialogFooter,
    PrimaryButton,
    DefaultButton
} from '@fluentui/react';

const GoogleAnalyticsConfirmationModal = ({
    fetchAllGa4Properties,
    setupGa,
    isEditModalOpen,
    setIsEditModalOpen,
    selectedPropertyForEdit,
    loadingSetupGa,
    ga4Account,
    values,
    setToastMessage,
    setShowToast,
    selectedPropertyLevel,
    setDisplayedGa4Properties,
}) => {

    return (
        <div className="form-group" style={{ display: 'flex', flexDirection: 'column', alignSelf: 'flex-start', marginTop: '20px', gap: '10px' }}>
            <Dialog
                hidden={!isEditModalOpen}
                onDismiss={() => setIsEditModalOpen(false)}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Confirm Edit',
                    subText: `Are you sure you want to edit the settings for the '${selectedPropertyLevel === 'CobrandTag' ? 'cobrand tag' : selectedPropertyLevel}' level? This will erase any old data.`
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton
                        text="Continue"
                        onClick={() => {
                            setIsEditModalOpen(false);
                            const payload = {
                                cobrandId: values.cobrandId,
                                clientId: values.clientId ? values.clientId : 0,
                                isEnrich: values.platformId === 2,
                                GA4Account: values.ga4Account,
                                levels: [selectedPropertyLevel],
                                cobrandDisplayName: values.cobrandDescription,
                                clientDisplayName: values.clientDescription
                            };

                            setupGa({ data: payload })
                                .then(response => {
                                    const responseData = response.data;

                                    if (Array.isArray(responseData) && responseData.length > 0) {
                                        responseData.forEach((item, index) => {

                                            const propertyId = item.gaProperty?.propertyName?.propertyId;
                                            const measurementId = item.gaDataStream?.webStreamData?.measurementId;

                                            if (!propertyId) console.warn(`Missing propertyId for level ${item.level}`);
                                            if (!measurementId) console.warn(`Missing measurementId for level ${item.level}`);

                                            if (item.level === 'Client') {
                                                setFieldValue('gaClientPropertyId', propertyId || '');
                                                setFieldValue('gaClientMeasurementId', measurementId || '');
                                            } else if (item.level === 'Cobrand') {
                                                setFieldValue('gaCobrandPropertyId', propertyId || '');
                                                setFieldValue('gaCobrandMeasurementId', measurementId || '');
                                            } else if (item.level === 'CobrandTag') {
                                                setFieldValue('gaCobrandTagPropertyId', propertyId || '');
                                                setFieldValue('gaCobrandTagMeasurementId', measurementId || '');
                                            }

                                            setDisplayedGa4Properties(prevProps =>
                                                prevProps.map(prop =>
                                                    prop.level === item.level
                                                        ? { ...prop, propertyId, measurementId }
                                                        : prop
                                                )
                                            );
                                        });

                                        fetchAllGa4Properties().then((resp) => {
                                            const allProps = resp?.data || [];

                                            allProps.forEach((item, index) => {
                                                const propertyId = item.gaProperty?.propertyName?.propertyId;
                                                const measurementId = item.gaDataStream?.webStreamData?.measurementId;
                                                if (item.level === 'Client') {
                                                    setFieldValue('gaClientPropertyId', propertyId || '');
                                                    setFieldValue('gaClientMeasurementId', measurementId || '');
                                                } else if (item.level === 'Cobrand') {
                                                    setFieldValue('gaCobrandPropertyId', propertyId || '');
                                                    setFieldValue('gaCobrandMeasurementId', measurementId || '');
                                                } else if (item.level === 'CobrandTag') {
                                                    setFieldValue('gaCobrandTagPropertyId', propertyId || '');
                                                    setFieldValue('gaCobrandTagMeasurementId', measurementId || '');
                                                }
                                            });

                                            setDisplayedGa4Properties(allProps);
                                            setToastMessage("GA data generated successfully.");
                                            setShowToast(true);
                                        }).catch(fetchErr => {
                                            setToastMessage("Failed to fetch complete GA4 data.");
                                            setShowToast(true);
                                        });

                                    } else {
                                        console.warn("GA data response was not in the expected format or was empty:", responseData);
                                        setToastMessage("GA data response was not in the expected format or was empty.");
                                        setShowToast(true);
                                    }
                                })
                                .catch(err => {
                                    console.error("GA setup request failed:", err);
                                    setToastMessage("Failed to generate GA data.");
                                    setShowToast(true);
                                });

                        }}
                        disabled={loadingSetupGa || !ga4Account}
                    />
                    <DefaultButton onClick={() => setIsEditModalOpen(false)} text="Cancel" />
                </DialogFooter>
            </Dialog>
        </div>
    )
};

export default GoogleAnalyticsConfirmationModal;
